export default "__VITE_ASSET__eTvDPIE1__"